import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { InfoContent, InfoLabel, InfoRow } from '@/components/InfoRow'
import Resx from '@/components/Resx'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle, WhiteBox } from '@/components/Layout'
import context from '@/context'
import { Button } from '@/components/button'
import Icon from '@/components/Icon'
import LoadingIndicator from '@/components/LoadingIndicator'
import { usePermissionChecker } from '@/hooks/usePermissionChecker'
import { BsrsGrid, Column, commandColumnProps, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import moment from 'moment'
import { useLocalization } from '@/hooks/localization'
import { getStore } from '@/store'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import CheckBox from '@/components/CheckBox'

function ReportCategoryDetail (props) {
  const id = props.match.params.id

  const [item, setItem] = useState(null)
  const [lastReloadedAt, setLastReloadedAt] = useState(moment())
  const [includeDeleted, setIncludeDeleted] = useState(false)

  const isGranted = usePermissionChecker()
  const { localize } = useLocalization()

  const canEdit = isGranted('CanManageReportingConstants')

  useEffect(() => {
    context.api.reportConstantService.getCategory(id)
      .then(r => {
        setItem(r)
        setLastReloadedAt(moment())
      })
      .catch()
  }, [id])

  const dataSourceRequest = useCallback(request => context.api.reportConstantService
    .getConstantsList(request, id, includeDeleted), [id, includeDeleted])

  const openEditDialog = useCallback((apiCall, item) => getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.editConstant,
    item: item,
    categoryId: id,
    onAction: newItem => apiCall(newItem).then(setTimeout(() => setLastReloadedAt(moment()), 500))
  })), [id])

  const onAddClick = useCallback(() => openEditDialog(context.api.reportConstantService.createConstant, null),
    [openEditDialog])

  const onDelete = useCallback(item => {
    context.api.reportConstantService.deleteConstant(item.id).then(setLastReloadedAt(moment())).catch()
    setLastReloadedAt(moment())
  }, [])

  const onIncludeDeletedChange = useCallback(e => {
    setIncludeDeleted(e)
    setLastReloadedAt(moment())
  }, [setIncludeDeleted])

  return !item
    ? <LoadingIndicator />
    : <Main>
      <MainTop>
        <MainTopTitle backUrl={'/report-constant-categories'}><Resx name='Common.ReportConstants' /></MainTopTitle>
        {canEdit && <MainTopLeft>
          <Button color='primary' className='btn btn-md' onClick={onAddClick}>
            <Icon name='plus' />
            <Resx name={'Common.Add'} />
          </Button>
        </MainTopLeft>}
      </MainTop>
      <MainBody>
        <WhiteBox header='Reporting.General'>
          <Row>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.Name' /></InfoLabel>
                <InfoContent>{item.name}</InfoContent>
              </InfoRow>
            </Col>
            <Col sm='6'>
              <InfoRow>
                <InfoLabel><Resx name='Common.LatinName' /></InfoLabel>
                <InfoContent>{item.latinName}</InfoContent>
              </InfoRow>
            </Col>
          </Row>
        </WhiteBox>
        <WhiteBox header='Common.Constants'>
          <CheckBox title='Common.IncludeDeleted' checked={includeDeleted} onChange={onIncludeDeletedChange} />
          <BsrsGrid lastReloadedAt={lastReloadedAt} sortable={{ mode: 'multiple' }} defaultSort={[{ field: 'key', dir: 'asc' }, { field: 'validTo', dir: 'asc' }]} dataSource={dataSourceRequest}>
            <Column type='nonNullable' field='id' filter='numeric' title={localize('Common.Id')} editable={false} bleeeeeeeeee />
            <Column field='key' title={localize('Common.Key')} editable={false} />
            <Column field='value' title={localize('Common.Value')} editable={false} />
            <Column field='validFrom' title={localize('Common.ValidFrom')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
            <Column field='validTo' title={localize('Common.ValidTo')} filter='date' cell={DateCell} filterCell={DateFilterCell} editable={false} />
            <Column {...commandColumnProps({
              deleteAction: onDelete,
              deleteDisabled: x => !canEdit || !x.enabled,
              editDisabled: x => !canEdit || !x.enabled,
              editAction: x => openEditDialog(context.api.reportConstantService.updateConstant, x)
            })} title=' ' width={150} />
          </BsrsGrid>
        </WhiteBox>
      </MainBody>
    </Main>
}

export { ReportCategoryDetail }



// WEBPACK FOOTER //
// ./src/internal-app/pages/administration/report-constants/reportCategoryDetail.js